import invoiceInstance from '../instance'

const updateInvoiceStatus = (invoiceUuid, markAsPaid) => {
	return invoiceInstance.put(`/invoices/${invoiceUuid}/status`, { markAsPaid })
}

export default updateInvoiceStatus
